import { IGST } from '../../../utils/entities/interface';
import { ListTable } from '../../molecules/ListTable';
import moment from 'moment';

export const Taxaxtion = ({
  taxList,
  isLoading,
  headerCells,
}: {
  taxList: IGST[];
  isLoading: boolean;
  headerCells: [string, number][];
}) => {
  return (
    <ListTable
      headerCells={headerCells}
      rows={taxList}
      isLoading={isLoading}
      renderCell={(tax: IGST, colIndex: number) => {
        switch (colIndex) {
          case 0:
            return tax.name;
          case 1:
            return tax.gst + '%';
          case 2:
            return moment(tax.effectiveFrom).format('DD/MM/YYYY');
          case 3:
            return (
              <span className={!tax.isActive ? 'inActiveClass' : 'activeClass'}>
                {tax.isActive ? 'Active' : 'Inactive'}
              </span>
            );
          default:
            return null;
        }
      }}
    />
  );
};
